import { useState } from "react";

import DataTable from "react-data-table-component";
import TableLoader from "./TableLoader";

import useProjects from "../hooks/useProjects";

import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const AdminProjectTable = ({ onProjectClicked }) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const { data, isLoading } = useProjects({ page, perPage, status: 'Active' });

  const projects = data?.projects;
  const projectCount = data?.count;

  const handlePageChange = page => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const columns = [
    {
      name: "Project",
      selector: (row) => row.name,
      grow: 2
    },
    {
      name: "Start Date",
      selector: (row) => row.startDate,
      format: (row) => formatDateToSydneyTimeZone(row.startDate)
    },
    {
      name: "End Date",
      selector: (row) => row.endDate,
      format: (row) => formatDateToSydneyTimeZone(row.endDate)
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={projects}
      striped
      highlightOnHover
      pagination
      paginationServer
      pointerOnHover
      onRowClicked={onProjectClicked}
      progressPending={isLoading}
      progressComponent={<TableLoader />}
      paginationTotalRows={projectCount}
      paginationRowsPerPageOptions={[10, 20, 50]}
      paginationPerPage={perPage}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handlePerRowsChange}
    />
  );
};

export default AdminProjectTable;
